import React from 'react';

export default function TcgPopulateButton({
  onPopulate,
  populating,
  status,
  onReset,
  resetting,
}) {
  const anyRunning = populating || resetting;

  return (
    <div className="scrape-button-container">
      <button
        className="btn btn-primary"
        onClick={onPopulate}
        disabled={anyRunning}
      >
        {populating ? 'Populating...' : 'Populate TCG Reference'}
      </button>
      <button
        className="btn btn-danger"
        onClick={onReset}
        disabled={anyRunning}
        style={{ marginLeft: '8px' }}
      >
        {resetting ? 'Resetting...' : 'Reset & Repopulate'}
      </button>
      {status && (
        <div className="scrape-status">
          <span className={`status-badge status-${status.status}`}>
            {status.status}
          </span>
          {(status.sets_total > 0 || status.cards_total > 0) && (
            <span className="status-detail">
              Sets: {status.sets_done}/{status.sets_total}
              {' | '}
              Cards: {status.cards_done?.toLocaleString()}/{status.cards_total?.toLocaleString()}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
